import { render } from "./Grupos.page.vue?vue&type=template&id=88717bb0&ts=true"
import script from "./Grupos.page.vue?vue&type=script&lang=ts"
export * from "./Grupos.page.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__